import {TeamPlanLeadFormEvent} from './team-plan-lead-form-event';

type TeamPlanLeadFormSubmissionFailedProperties = {
    formId: string;
    failureReason: string;
};

/**
 * Amplitude event fired when the Team Plan sign-up form submission fails,
 * capturing the reason (HTTP status or network error).
 */
export class TeamPlanLeadFormSubmissionFailedEvent extends TeamPlanLeadFormEvent {
    private readonly failureReason: string;

    constructor(formId: string, failureReason: string) {
        super('tp_lead_form_submission_failed', formId);
        this.failureReason = failureReason;
    }

    override toEventProperties(): TeamPlanLeadFormSubmissionFailedProperties {
        return {
            ...super.toEventProperties(),
            failureReason: this.failureReason,
        };
    }
}
